

<div class="add-foreclosure-auction-card">
  <form [formGroup]="addForeclosureAuctionForm"  name="addForeclosureAuctionForm" (ngSubmit)="submitAddForeclosureAuctionForm()" class="add-bid-form">
      <div class="form-group">
          <div class="ui-grid-row form-field-label">
              <div class="ui-grid-col-12">
              <label for="propertyStates">Property State <span class="custom-required">*</span></label>
              </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center"> 
                  <p-dropdown #selectState  [options]="propertyStates" 
                      [(ngModel)]="selectedPropertyState"
                      formControlName="PropertyStates" 
                      [placeholder]="'Select One'" 
                      styleClass="add-bid-dropdown"
                      (onChange)="populateCounty()"
                      filter="true" 
                      filterBy="label,value">                        
                  </p-dropdown>
              </div>
          </div>

          <div class="ui-grid-row form-field-label">
              <div class="ui-grid-col-12">
              <label for="county">County <span class="custom-required">*</span></label>
              </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center">
                  <p-dropdown #selectState  [options]="county" 
                    formControlName="County" 
                    [placeholder]="'Select One'" 
                    styleClass="add-bid-dropdown"
                    filter="true" 
                    filterBy="label,value">                        
                  </p-dropdown>
                  <!-- <span *ngIf="county.touched && county.length == 0" class="custom-error">Please select state and then select trustee.</span> -->
              </div>                
          </div>

          <div class="ui-grid-row form-field-label">
            <div class="ui-grid-col-12">
              <label for="AuctionLocationAddress">Auction Location Address <span class="custom-required">*</span></label>
            </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center">
                <input type="text" pInputText  
                  placeholder="Auction Location Address" 
                  formControlName="AuctionLocationAddress" style="width:200px"/>
              </div>
              <span *ngIf="addForeclosureAuctionForm.get('AuctionLocationAddress').touched && addForeclosureAuctionForm.get('AuctionLocationAddress').invalid" style="color:red">
                Special characters like @ ! * are not allowed
              </span>                
          </div>

          <div class="ui-grid-row form-field-label">
            <div class="ui-grid-col-12">
              <label for="AuctionLocationDetails">Auction Location Details</label>
            </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center">
                <input type="text" pInputText  placeholder="Auction Location Details" formControlName="AuctionLocationDetails"  style="width:200px" />
              </div>                
          </div>

          <div class="ui-grid-row form-field-label">
              <div class="ui-grid-col-12">
              <label for="StatutaryLocation">Statutory Location </label>
              </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center">
                  <div class="ui-g-12" style="display: flex;">
                      <p-radioButton name="StatutaryLocation" [(ngModel)]="staturtaryValue"
                        formControlName="StatutaryLocation" 
                        class="radio-margin" value="1" label="Yes"></p-radioButton>
                      <p-radioButton name="StatutaryLocation" [(ngModel)]="staturtaryValue"
                        formControlName="StatutaryLocation" 
                        value="0" label="No"></p-radioButton>
                  </div>
              </div>
          </div>

          <div class="add-bid-button-block">
              <button pButton type="button" 
                  label="Cancel" 
                  class="ui-button-secondary add-bid-button" 
                  (click)="hideAddForeclosureAuctionForm()">
              </button>
              <button pButton type="submit" 
                  label="{{processing ? 'Saving..' : 'Add Foreclosure Auction Location'}}" 
                  class="add-bid-button" 
                  [disabled]="addForeclosureAuctionForm.invalid">
              </button>
          </div>
      </div>
  </form>    
</div><br/>